module.exports = __webpack_public_path__ + "static/media/brownrice.241ad024.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/base/brownrice.jpg
// module id = 97
// module chunks = 0